// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"97876c4d","657":"ad1895fa"}[chunkId] + ".chunk.css";
};